module.exports = __webpack_public_path__ + "static/img/front-SFG116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_front/front-SFG116.png
// module id = tmgh
// module chunks = 0